import { Icon } from 'components'
import { cookies } from 'lib/cookies'
import { getKeyRemoteConfig } from 'lib/firebase'
import { useEffect, useRef, useState } from 'react'

export const UnavailableService = () => {
  const containerAlertRef = useRef<HTMLDivElement>(null)
  const [message, setMessage] = useState<string>('')

  const getMessageRemoteConfig = async () => {
    const messageRemoteConfig = await getKeyRemoteConfig(
      'candidature_service_unavailable'
    )

    if (!!messageRemoteConfig) {
      setMessage(messageRemoteConfig)
    }
  }

  useEffect(() => {
    const token = cookies.get('token')
    if (token) getMessageRemoteConfig()
  }, [])

  useEffect(() => {
    if (message && containerAlertRef.current) {
      const height = containerAlertRef.current.clientHeight
      document.body.style.paddingTop = `${height}px`
    }
  }, [message])

  if (!message) return <></>

  return (
    <div
      role="alert"
      ref={containerAlertRef}
      className="absolute top-0 left-0 right-0 py-3 px-2 flex justify-center bg-[#FFDF2D]"
    >
      <p className="flex items-center justify-center gap-2 w-full max-w-7xl text-gray-800 font-medium">
        <Icon face="warning" size="md" variant="round" />
        <span className="text-body2">{message}</span>
      </p>
    </div>
  )
}
